const getPatientViewerModulePrefix = (moduleKey: any) =>
  `patientViewer-module:${moduleKey}`;

const contextKeys = {
  patientViewer: {
    patient: 'patientViewer-patient',
    headerTagQuery: (resourceType: any, tagSystem: any, tagCode: any) =>
      `patientViewer-headerField-tagQuery-${resourceType}-${tagSystem}-${tagCode}`,
    fetchLayoutConfigurations: 'patientViewer-fetchLayoutConfiguration',
    updateLayoutConfigurations: 'patientViewer-updateLayoutConfiguration',
    deleteLayoutConfigurations: 'patientViewer-deleteLayoutConfiguration',
    createLayoutConfigurations: 'patientViewer-createLayoutConfiguration',
    fetchDownloadLink: (moduleKey: any, fileKey: any) =>
      `${getPatientViewerModulePrefix(
        moduleKey,
      )}-fetchDownloadLink-file:${fileKey}`,
    getModulePrefix: getPatientViewerModulePrefix,
    variants: {
      getSequenceKey: (moduleKey: any) =>
        `${getPatientViewerModulePrefix(moduleKey)}-patientSequences`,
      getVariantsKey: (moduleKey: any) =>
        `${getPatientViewerModulePrefix(moduleKey)}-sequenceVariants`,
    },
    getTraceKey: (moduleKey: any, traceKey: any, extraIdentifier: any) =>
      `${getPatientViewerModulePrefix(moduleKey)}-trace:${traceKey}-id:${
        extraIdentifier || ''
      }`,
    getTableKey: (moduleKey: any) =>
      `${getPatientViewerModulePrefix(moduleKey)}-table`,
    codeSearch: 'patientViewer-codeSearch',
    projectSearch: 'patientViewer-projectSearch',
    fileSearch: 'patientViewer-fileSearch',
    updatePatient: 'patientViewer-updatePatientResource',
    fectchProjectSurveys: 'patientViewer-fetchProjectSurveys',
    createUserSurvey: 'patientViewer-createUserSurvey',
    fetchSubjectResponses: 'patientViewer-fetchSubjectResponses',
    fetchResponseSurvey: 'patientViewer-fetchResponseSurvey',
    deleteSurveyResponse: (responseId: any) =>
      `patientViewer-deleteSurveyResponse-${responseId}`,
    fetchSubjectConsents: 'patientViewer-fetchSubjectConsents',
    fetchSubjectConsentResponses: 'patientViewer-fetchSubjectConsentResponses',
    fetchConsentQuestionnaire: 'patientViewer-fetchConsentQuestionnaire',
    fetchConsentResposne: 'patientViewer-fetchConsentResposne',
    fetchSurveyListGroups: 'patientViewer-fetchSurveyListGroups',
    sendSurveyInvite: 'patientViewer-sendSurvey',
  },
  subjectAutosuggest: 'subject-autosuggest-search',
  fileManagement: (fileId: any) => ({
    deleteFileContextKey: `fileManagement-deleteFile-${fileId}`,
    renameFileContextKey: `fileManagement-renameFile-${fileId}`,
    fetchDownloadLinkContextKey: `fileManagement-fetchDownloadLink-${fileId}`,
    fetchOpenLinkContextKey: `fileManagement-fetchOpenLink-${fileId}`,
  }),
  filesPage: (projectId: any, path: any) => ({
    fetchFiles: `files-fetch-project-${projectId}-path=${path}`,
  }),
  patientSearch: {
    patientService: 'patient-search-patient-service',
    cohortsService: 'patient-search-cohorts-service',
  },
  lxInvites: {
    accountGroups: (accountId: any) => `lxAccountInvites-account:${accountId}`,
    sendLxInvite: 'lxAccountInvites-sendInvite',
  },
  openLinkInvitations: {
    accountGroups: (accountId: any) => `openLinkInvites-account:${accountId}`,
  },
  geneSets: {
    queryGeneSets: 'genesets-query',
    createGeneSet: 'genesets-create',
    deleteGeneSet: 'genesets-delete',
    updateGeneSet: 'genesets-update',
  },
  genes: {
    queryGenes: 'genes-query',
    validateGenes: 'validate-genes',
  },
  accountManagement: {
    invitations: {
      invitationsDisplayList: 'account-management-invitations-display-list',
      sentInvitationsDisplayList:
        'account-management-sent-invitations-display-list',
      accountInvitationsDisplayList:
        'account-management-account-invitations-display-list',
    },
    apiKeys: {
      apiKeyList: 'account-management-api-keylist',
    },
    projectsManagement: {
      projectsDisplayList: 'account-management-projects-display-list',
      projectAnalytics: 'account-management-projects-query-analytics',
    },
    accessControl: {
      policyList: 'account-management-policy-list',
      policyEditor: {
        projectCache: 'account-management-policy-editor-project-cache',
        groupCache: 'account-management-policy-editor-group-cache',
        projectsSelectionList: 'account-management-policy-projects-list',
        groupsSelectionList: 'account-management-policy-groups-list',
      },
    },
    groupManagement: {
      groupDisplayList:
        'account-management-group-management-group-display-list',
      groupMembers: 'account-management-group-management-group-members',
    },
    logo: {
      uploadLogo: (accountId: any) =>
        `account-management-fetch-upload-logo-account:${accountId}`,
    },
  },
  tasks: {
    tasksDisplayList: 'tasks-display-list',
    taskFetchState: (id: any) => `task-fetch-state:${id}`,
  },
  workflows: {
    workflowsDisplayList: 'workflows-display-list',
    workflowFetchState: (id: any) => `workflow-fetch-state:${id}`,
  },
  consent: {
    projectConsentsListContextKey: 'consent-project-consents',
    consentFormsListContextKey: 'consent-forms',
    groupListContextKey: 'consent-groups',
    fetchUserConsent: 'consent-fetch-user-consent',
    fetchConsentQuestionnaire: 'consent-detail-fetch-questionnaire',
    fetchConsentQuestionnaireResponse:
      'consent-detail-fetch-questionnaireResponse',
    rootGroupQuery: 'rootGroupQuery',
  },
  notes: {
    fetchNotes: 'fetch-notes',
    searchNotes: 'search-notes',
    deleteNote: 'delete-note',
    updateNote: 'update-note',
    createNote: 'create-note',
  },
  genomics: {
    variantSetsDisplayList: 'variant-sets-display-list',
    variantsDisplayList: 'variants-display-list',
    readSetsDisplayList: 'read-sets-display-list',
    expressionSetsDisplayList: 'expression-sets-display-list',
  },
  insights: {
    demographics: 'insights-demographics',
    codeSearch: 'insights-codeSearch',
    insightsChart: (moduleKey: any) => `insights-chart-module:${moduleKey}`,
    insightsChartEntireProject: (moduleKey: any) =>
      `insights-chart-module-entire-project:${moduleKey}`,
    insightsChartComparisonItem1: (moduleKey: any) =>
      `insights-chart-module-compare-1:${moduleKey}`,
    insightsChartComparisonItem2: (moduleKey: any) =>
      `insights-chart-module-compare-2:${moduleKey}`,
    filterContractEvaluation: 'insights-filter-contract-evaluation',
  },
  cohorts: {
    cohortsDisplayList: 'cohorts-display-list',
  },
  circles: {
    fetchUserCircles: 'circles-fetch-user-circles',
    createUserCircle: 'circles-add-user-circle',
    editUserCircle: 'circles-edit-user-circle',
    fetchImageUploadUrl: 'circles-fetch-image-upload-url',
    uploadCircleImage: 'circles-upload-circle-image',
  },
  indirectImage: {
    fetchDownloadUrl: (initialUrl: any) =>
      `indirectImage-fetch-download-url-${initialUrl}`,
  },
  subjects: {
    subjectSearch: 'subject-search',
  },
  omicsExplorer: {
    patient: (subjectId: any) => `omicsExplorer-patient-${subjectId}`,
    sequencesForSubject: (subjectId: any) =>
      `omicsExplorer-sequences-${subjectId}`,
    sequenceShortVariantCount: 'omicsExplorer-sequence-variant-counts-short',
    sequenceCopyNumberVariantCount:
      'omicsExplorer-sequence-variant-counts-copyNumber',
    sequenceStructuralVariantCount:
      'omicsExplorer-sequence-variant-counts-structural',
    sequenceExpressionCount: 'omicsExplorer-sequence-variant-counts-expression',
    geneSets: 'omicsExplorer-geneSets',
    summaryForSubject: (subjectId: any) => `omicsExplorer-summary-${subjectId}`,
    summaryForTest: (testId: any) => `omicsExplorer-summary-test-${testId}`,
    shortVariants: 'omicsExplorer-query-short-variants',
    structuralVariants: 'omicsExplorer-query-structural-variants',
    copyNumberVariants: 'omicsExplorer-query-copy-number-variants',
    expressionVariants: 'omicsExplorer-query-expression-variants',
  },
  surveys: {
    fetchSurveys: 'surveys-fetchSurveys',
    fetchSurveyResultsSurvey: 'surveys-fetchSurveyResultsSurvey',
    fetchSurveyById: 'surveys-fetchProjectSurveys',
    fetchSurveyResponses: 'surveys-fetchSurveyResponses',
    fetchResponsePatients: 'surveys-fetchSurveyResponsePatients',
    sendSurvey: 'surveys-sendSurvey',
    subjectSurveys: 'subject-surveys',
    subjectSurveyResponses: 'subject-survey-responses',
    validatePatientRequest: 'surveys-validatePatient',
    updateSurveyResponse: 'surveys-updateResponse',
    createSurvey: 'surveys-create-survey',
    sendNewUserSurvey: 'surveys-send-new-user-survey',
    inviteNewUserGroups: 'surveys-invite-new-user-groups',
    sendExistingUserSurvey: 'surveys-send-existing-user-survey',
    fetchUserSurveys: 'surveys-fetch-user-surveys',
    createNewSurveyRespone: 'surveys-create-new-survey-response',
    createSurveyInviteLink: 'surveys-create-open-invite-link',
    acceptOpenInviteSurvey: 'surveys-accept-open-invite',
  },
  ontology: {
    resourceSelect: {
      allTerms: (id: any) =>
        `resource-select-field-all-terms${id && `--${id}`}`,
      relatedTerms: (id: any) =>
        `resource-select-field-related-terms${id && `--${id}`}`,
    },
    suggest: 'ontology-suggest',
    search: 'ontology-search',
    searchPage: {
      getAllTerms: 'search-page-ontology-get-all-terms',
    },
  },
  appInvites: {
    getInviteById: 'app-invites-invite-by-id',
    acceptInvite: 'app-invites-accept-invite',
    rejectInvite: 'app-invites-reject-invite',
  },
};

/**
 * Retrieves all of the async request context keys for this module
 * @param {*} requestContexts - All the async request contexts in the state
 * @param {*} moduleKey - The identifier for this module
 */
export const getModuleRequestContextKeys = (
  stateRequestContexts: any,
  moduleKey: any,
) => {
  const moduleKeyPrefix = contextKeys.patientViewer.getModulePrefix(moduleKey);
  const stateRequestContextKeys = Object.keys(stateRequestContexts || {});
  return stateRequestContextKeys.filter(key => key.startsWith(moduleKeyPrefix));
};

export default contextKeys;
